import { sendAssert } from '../services/assert.service.js'

const ASSERT_BREAKS_THINGS = process.env.ASSERT_BREAKS_THINGS

export function assertUUID(value, message) {
  // regex for uuid validation
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  assert(typeof value === 'string' && uuidRegex.test(value), message, { value })
}

/** 
 * @type {Assert} 
 * @returns {boolean} true if assertion passes, false if it fails
 */
export function assert(condition, message, data = null) {
  if (!condition) {
    const error = new Error()
    const stackLines = error.stack.split('\n')
    const location = stackLines[2]?.trim() || 'Unknown location'

    const errorInfo = {
      location,
      message,
      data,
      stack: error.stack,
      timestamp: Math.floor(Date.now() / 1000),
      userAgent: navigator.userAgent,
      url: window.location.href,
    }
    
    // Send to /assert endpoint asynchronously
    sendAssert(errorInfo).catch(err => {
      console.error('Failed to send assertion to server:', err)
    })

    // @ts-ignore
    if (ASSERT_BREAKS_THINGS == 'true' || ASSERT_BREAKS_THINGS == true) {
      const details = `
        <div class="error-section" style="
            background: #2a2a2a;
            padding: 1rem;
            margin: 0.5rem 0;
            border-radius: 4px;
          ">
          <h3 style="margin: 0 0 0.5rem 0; color: #ff8888;">Data:</h3>
          <pre>${JSON.stringify(data, null, 2)}</pre>
        </div>
      `

      document.body.innerHTML = `
        <div style="
          color: #ff6b6b;
          padding: 2rem;
          font-family: monospace;
          width: 100%;
          box-sizing: border-box;
          background: #1a1a1a;
          line-height: 1.5;
        ">
          <h1 style="margin: 0 0 1rem 0; color: #ff4444;">💥 FATAL ERROR</h1>
          
          <div class="error-section" style="
            background: #2a2a2a;
            padding: 1rem;
            margin: 0.5rem 0;
            border-radius: 4px;
          ">
            <h3 style="margin: 0 0 0.5rem 0; color: #ff8888;">Location:</h3>
            <div style="white-space: normal; word-wrap: break-word;">${location}</div>
          </div>

          <div class="error-section" style="
            background: #2a2a2a;
            padding: 1rem;
            margin: 0.5rem 0;
            border-radius: 4px;
          ">
            <h3 style="margin: 0 0 0.5rem 0; color: #ff8888;">Message:</h3>
            <div style="white-space: normal; word-wrap: break-word;">${message}</div>
          </div>

          ${details}

          <div class="error-section" style="
            background: #2a2a2a;
            padding: 1rem;
            margin: 0.5rem 0;
            border-radius: 4px;
          ">
            <h3 style="margin: 0 0 0.5rem 0; color: #ff8888;">Stack Trace:</h3>
            <div style="white-space: normal; word-wrap: break-word;">${error.stack}</div>
          </div>
        </div>
      `
    } else {
      error.message = `Assertion failed: ${message}\nLocation: ${location}\nData: ${JSON.stringify(data, null, 2)}`
      console.error("Assertion failed: ", errorInfo)
      throw error
    }

    return false
  }

  return true
}
